<template>
  <a-config-provider :locale="pl_PL">
    <div v-if="!computedSession.loaded" class="loading-wall">
      <p><img alt="Logo" src="@/assets/logo-light.png" style="margin-bottom: 120px; width: 180px"/></p>
      <p><a-spin tip="Ładowanie..."/></p>
    </div>
    <a-layout id="app">
      <a-layout-header :style="{
        position: 'fixed',
        zIndex: 1,
        width: '100%',
        userSelect: 'none',
        background: 'white'
      }">
        <div class="logo">
          <img alt="Logo" src="@/assets/logo-light.png" style="cursor: pointer"
               @click="computedSession.isLoggedIn ? goTo({ name: 'Home' }) : goTo({ name: 'Login' })"/>
        </div>
        <a-menu :style="{ lineHeight: '64px' }" mode="horizontal" theme="light">
          <!-- RIGHT -->
          <a-sub-menu v-if="computedSession.isLoggedIn" key="99" :style="{ float: 'right' }">
            <span slot="title"><a-icon type="user"/><span>Profil</span></span>
            <a-menu-item key="991" @click="changePassword"> Zmień hasło</a-menu-item>
            <a-menu-item key="992" @click="logout"> Wyloguj</a-menu-item>
          </a-sub-menu>
          <a-menu-item v-else key="98" :style="{ float: 'right' }" @click="goTo({ name: 'Login' })">
            <a-button type="primary">
              Zaloguj się
            </a-button>
          </a-menu-item>
          <a-menu-item v-if="computedSession.isLoggedIn" key="96" :style="{ float: 'right' }" class="no-bottom-active">
            <a href="https://support.togi.me" target="_blank">
              <a-button type="default" icon="message">
                Support Center
              </a-button>
            </a>
          </a-menu-item>
          <a-menu-item key="95" :style="{ float: 'right' }" class="no-bottom-active">
            <a-spin :style="{
              transform: loadingIndicator ? 'scale(1,1)' : 'scale(0,0)',
              opacity: loadingIndicator ? '1' : '0',
            }" class="loader"/>
          </a-menu-item>
        </a-menu>
      </a-layout-header>
      <a-layout>
        <a-layout-sider v-if="computedSession.isLoggedIn" style="background: #fff; margin-bottom: 0"
                        width="200">
          <a-menu :selected-keys="currentSelectedMenuKey" :style="{ height: '100%', borderRight: 1, paddingTop: '74px' }"
                  mode="inline">
            <a-menu-item key="1" @click="goTo({ name: 'Home' })">
              <a-icon type="dashboard"/>
              <span class="nav-text">Dashboard</span>
            </a-menu-item>
            <a-menu-item key="2" @click="goTo({ name: 'Users' })">
              <a-icon type="team"/>
              <span class="nav-text">Użytkownicy</span>
            </a-menu-item>
            <a-menu-item v-if="false" key="3" disabled @click="goTo({ name: 'Devices' })">
              <a-icon type="api"/>
              <span class="nav-text">Urządzenia</span>
            </a-menu-item>
            <!-- <a-menu-item key="4" @click="goTo({ name: 'Analitycs' })" disabled>
              <a-icon type="pie-chart" />
              <span class="nav-text">Analityka</span>
            </a-menu-item> -->
            <!-- <a-menu-item key="5" @click="goTo({ name: 'Calendar' })" disabled>
              <a-icon type="calendar" />
              <span class="nav-text">Kalendarz</span>
            </a-menu-item> -->
            <a-menu-item key="6" @click="goTo({ name: 'Issues' })">
              <a-icon type="message"/>
              <span class="nav-text">Zgłoszenia</span>
            </a-menu-item>
            <a-menu-item v-if="false" key="7" disabled @click="goTo({ name: 'Announcements' })">
              <a-icon type="notification"/>
              <span class="nav-text">Ogłoszenia</span>
            </a-menu-item>
            <a-menu-item v-if="false" key="8" disabled @click="goTo({ name: 'Codes' })">
              <a-icon type="qrcode"/>
              <span class="nav-text">Kody dostępowe</span>
            </a-menu-item>
            <a-menu-item v-if="false" key="9" @click="goTo({ name: 'Approvals' })">
              <a-icon type="idcard"/>
              <span class="nav-text">Potwierdzenia</span>
            </a-menu-item>
            <a-menu-item key="10" @click="goTo({ name: 'Events' })">
              <a-icon type="history"/>
              <span class="nav-text">Zdarzenia</span>
            </a-menu-item>

            <a-divider/>

            <a-menu-item key="49" @click="goTo({ name: 'Nodes' })">
              <a-icon type="cluster"/>
              <span class="nav-text">Węzły</span>
            </a-menu-item>
            <a-menu-item key="50" @click="goTo({ name: 'Tools' })">
              <a-icon type="code"/>
              <span class="nav-text">Narzędzia</span>
            </a-menu-item>
            <a-menu-item v-if="false" key="51" disabled @click="goTo({ name: 'Configuration' })">
              <a-icon type="setting"/>
              <span class="nav-text">Konfiguracja</span>
            </a-menu-item>

            <a-divider v-if="false"/>

            <a-menu-item v-if="false" key="99" disabled @click="goTo({ name: 'Notifications' })">
              <a-icon type="bell"/>
              <span class="nav-text">
                <a-badge :numberStyle="{ marginRight: '-12px', fontSize: '0.8em', background: '#1890ff' }"
                         count="5">Powiadomienia</a-badge>
              </span>
            </a-menu-item>
          </a-menu>
        </a-layout-sider>
        <a-layout style="padding: 0 24px 24px">
          <a-layout-content :style="{
            padding: '0 50px',
            margin: '64px auto',
            width: '100%',
            maxWidth: '1980px'
          }">
            <a-breadcrumb :style="{ margin: '24px 0 16px', userSelect: 'none' }">
              <a-breadcrumb-item>Connect Ark</a-breadcrumb-item>
              <a-breadcrumb-item>{{ $route.meta.title }}</a-breadcrumb-item>
              <a-breadcrumb-item v-if="$route.meta.subtitle !== undefined">{{
                  $route.meta.subtitle
                }}
              </a-breadcrumb-item>
            </a-breadcrumb>

            <router-view @loadedView="stopLoadingAnimation"/>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <ChangePasswordModal :enabled="changePasswordModalShow" @close="changePasswordModalShow = false"/>
      <!-- <div v-if="loadingIndicator" :class="'full-page-loader ' + (loadingIndicator ? 'active' : '')">
      <a-row style="height: 100vh; padding-left: 16px; padding-right: 16px;" :gutter="[16, 16]" type="flex" align="middle"
        justify="space-around">
        <a-col :xs="24" :sm="24" :md="18" :lg="14" :xl="12" :xxl="8">
          <a-card>
            <a-result title="Ładowanie danych...">
              <template #icon>
                <a-spin size="large" />
              </template>
            </a-result>
          </a-card>
        </a-col>
      </a-row>
    </div> -->
      <div v-if="computedSession.isLoggedIn" class="visited-profiles ant-card">
        <a-row type="flex">
          <a-col flex="50px">
            <a-icon type="team" style="font-size: 2em; padding: 12px;"/>
          </a-col>
          <a-col flex="auto" style="padding: 12px 24px 12px 12px">
            <h3>Ostatnio odwiedzane profile</h3>
            <a-list item-layout="horizontal" size="small" :data-source="visitedProfiles">
              <a-list-item slot="renderItem" slot-scope="item" @click="item.current ? null : $router.push({ name: 'User', params: { uuid: item.accountUuid } })"
                           :style="{cursor: 'pointer', opacity: item.current ? '0.5' : '1' }">
                <a-list-item-meta>
                <span slot="title">
                  <a-badge :status="userStatusDictionary[item.status].badge"/>
                  {{ item.name }}
                </span>
                  <span slot="description" style="padding-left: 18px">
                    {{ item.identificationId }} &bull; {{ item.dorm.name }} &bull; {{ item.lastVisited }}
                  </span>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-col>
        </a-row>
      </div>
    </a-layout>
  </a-config-provider>
</template>

<script>
import pl_PL from 'ant-design-vue/lib/locale-provider/pl_PL';
import ChangePasswordModal from './components/account/ChangePasswordModal.vue';

const userStatusDictionary = {
  "INACTIVE": {badge: "default", name: "Nieaktywny"},
  "WAITING": {badge: "warning", name: "Weryfikacja dokumentu"},
  "DOCUMENT_APPROVED": {badge: "processing", name: "Oczekuje na aktywację"},
  "ACTIVE": {badge: "success", name: "Aktywny"},
  "BANNED": {badge: "error", name: "Zablokowany"},
  "DEPRECATED": {badge: "default", name: "Wygasły"},
}

export default {
  components: {
    ChangePasswordModal
  },
  data() {
    return {
      pl_PL,
      userStatusDictionary,
      loadingIndicator: true,
      currentSelectedMenuKey: ['1'],
      changePasswordModalShow: false,
      visitedProfiles: []
    };
  },
  beforeCreate() {
    this.$store.dispatch("getUserConnectionDetails");
  },
  mounted() {
    setInterval(() => {
      // Check if user is logged in
      let minutes = (new Date() - new Date(this.computedSession.lastUpdate)) / 1000 / 60
      if (minutes > 1) {
        this.$store.dispatch("getUserConnectionDetails");
      }
      if (!this.computedSession.isLoggedIn && (this.$route.meta.shouldBeLoggedIn !== undefined && this.$route.meta.shouldBeLoggedIn)) {
        this.goTo({name: 'Logout'})
      }

      // Get visited profiles
      this.refreshVisitedProfiles();
    }, 5000)
  },
  watch: {
    '$route.meta.menuKeyValue': {
      handler: function (menuKeyValue) {
        if (menuKeyValue !== undefined) {
          this.$nextTick(() => {
            this.currentSelectedMenuKey = []
            this.currentSelectedMenuKey.push(menuKeyValue)
          });
        }
        this.refreshVisitedProfiles();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    computedSession: function () {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  methods: {
    refreshVisitedProfiles() {
      this.visitedProfiles = JSON.parse(localStorage.getItem('visitedProfiles')) || [];
      this.removeOldProfiles();
      this.visitedProfiles.forEach((account) => {
        account.lastVisited = this.timeSince(account.lastVisited);
        if (this.$route.params.uuid === account.accountUuid) {
          account.lastVisited = 'Aktualnie wyświetlane';
          account.current = true
        } else {
          account.current = false
        }
      });
    },
    removeOldProfiles() {
      this.visitedProfiles = this.visitedProfiles.filter((account) => {
        return (new Date().getTime() - account.lastVisited) < 1000 * 60 * 60;
      });
      localStorage.setItem('visitedProfiles', JSON.stringify(this.visitedProfiles));
    },
    timeSince(timestamp) {
      const now = new Date().getTime();
      const seconds = Math.floor((now - timestamp) / 1000);

      if (seconds < 60) {
        return `${seconds} sek. temu`;
      } else {
        const minutes = Math.floor(seconds / 60);
        return `${minutes} min. temu`;
      }
    },
    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.loadingIndicator = true;
        this.$router.push(obj);
      }
    },
    stopLoadingAnimation() {
      this.loadingIndicator = false;
    },
    changePassword() {
      this.changePasswordModalShow = true
    },
    logout() {
      window.location.href = "/api/identity/logout?next=/account/logout"
    },
  },
};
</script>

<style>
body {
  background-color: Canvas;
  color: CanvasText;
  color-scheme: light dark;
}

#app {
  min-height: 100vh;
}

#app .logo {
  width: 120px;
  height: 31px;
  margin: 0px 24px 0px 0;
  float: left;
}

#app .logo img {
  width: inherit;
}

.with-love {
  height: 1em;
  margin: 0px 0.5em;
}

.footer {
  text-align: center;
  color: #7d7d7d;
}

.loader {
  -webkit-transition: all 1.5s ease-in-out;
  -moz-transition: all 1.5s ease-in-out;
  -o-transition: all 1.5s ease-in-out;
  transition: all 1.5s ease-in-out;
}

.ant-card,
.ant-layout-header {
  box-shadow: 0px 3px 10px rgba(100, 100, 100, 0.1);
}

.ant-card {
  border-radius: 12px;
}

.ant-card .ant-card {
  box-shadow: none;
}

.ant-card-actions {
  border-radius: 0px 0px 12px 12px;
}

.no-orphan {
  white-space: nowrap;
}

.full-page-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #f0f2f5;
  -webkit-transition: all 1.5s ease-in-out;
  -moz-transition: all 1.5s ease-in-out;
  -o-transition: all 1.5s ease-in-out;
  transition: all 1.5s ease-in-out;
  opacity: 0;
}

.full-page-loader.active {
  opacity: 1;
}

.ant-table td {
  white-space: nowrap;
}

.ant-divider-inner-text {
  font-size: 0.8em;
  line-height: 1.4em;
  margin-bottom: 4px;
}

.no-bottom-active.ant-menu-item-active,
.no-bottom-active.ant-menu-item-selected,
.no-bottom-active:hover,
.no-bottom-active {
  border: 0 !important;
}

.loading-wall {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #f0f2f5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.visited-profiles {
  display: block;
  width: 500px;
  min-height: 120px;
  position: fixed;
  z-index: 999;
  top: 126px;
  right: -450px;
  transition: all 0.5s ease-in-out;
}

.visited-profiles:hover {
  right: -10px;
}
</style>
